import { useContext, useMemo, useCallback } from 'react'
import { css } from '@emotion/react'
import { t } from '@lingui/core/macro'
import { object } from 'prop-types'
import { CvsAutoComplete, CvsTextField } from '@components'
import { connectorContext } from '@contexts'
import { templateCopyContext } from '../context'

const fullWidth = css`
  width: 100%;
`

export const FacebookAdsLink = ({ assignment }) => {
  const { onChange } = useContext(templateCopyContext)
  const { byId } = useContext(connectorContext)

  const connectors = useMemo(() => {
    const conns = Object.values(byId)
    return (
      conns.length &&
      conns
        .filter(
          connector =>
            connector.connector_type_id ===
            (assignment.connector_type_id
              ? assignment.connector_type_id
              : byId[assignment.connector_id].connector_type_id),
        )
        .map(({ name, id }) => ({
          label: name,
          value: id,
        }))
    )
  }, [assignment, byId])

  const onFacebookAdsLinkChange = useCallback(
    (value, name) => {
      onChange(old => ({
        ...old,
        [assignment.id]: {
          ...old[assignment.id],
          [name]: value,
        },
      }))
    },
    [(assignment, onChange)],
  )

  return (
    <div css={fullWidth}>
      <CvsTextField
        css={fullWidth}
        label={t`Integration name`}
        onChange={e => onFacebookAdsLinkChange(e.target.value, 'name')}
        value={assignment.name}
      />
      <CvsAutoComplete
        options={connectors || []}
        onSelected={selected => onFacebookAdsLinkChange(selected, 'connector_id')}
        selected={assignment.connector_id}
        label={t`Facebook account`}
      />
    </div>
  )
}

FacebookAdsLink.propTypes = {
  assignment: object.isRequired,
}
